export default __webpack_public_path__ + "static/media/armoire.d05083bf.png";